// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1ft1q","left":"InfoRow_left__uoxjs"};